import React,{Component} from 'react';

export class FooterContactSection extends Component {
	render(){
		return (
			<div className="contact-section">
				<div className="container">
				<div className="notice-box">
				<h4>Important Notice about Service</h4>
				<p>The Tax Court&rsquo;s rules permit service of documents via ePortal on parties who have opted to receive electronic service through ePortal (eService). Parties who have not opted into eService must be served by the alternative means provided in O.C.G.A. § 15-5B-12(f) (mail, statutory overnight delivery, or personal delivery).  In most instances, the last page of your eFiled document should include a &ldquo;Certificate of Service&rdquo; stating the date, place, and manner of service, as well as the names and addresses of the persons served. 
					<a className="notice-link"> <span>Click here for a sample Certificate of Service.</span></a> 
				</p>
				</div>
					
					<p><i className="fa fa-envelope" aria-hidden="true"></i> If you are having issues, please contact the Court at (404) 657-2806 or <a>tcfilinghelp@georgiacourts.gov</a></p>
				</div>
			</div>
		)
	}
}
